/**
 * Agents whose chat is just an input (house rule "no suggestion chips"; DollarStore staging sim r3: Saga's empty chat
 * still showed canned questions): no suggested prompts on an empty chat and no suggested replies. Saga is
 * campaign-manager, Lykke is account-manager.
 */
export const NO_CHIP_AGENTS: ReadonlySet<string> = new Set(['campaign-manager', 'account-manager']);

export const showsChips = (agentId: string | undefined | null): boolean => !agentId || !NO_CHIP_AGENTS.has(agentId);
